import { Theme, makeStyles, createStyles, alpha } from '@maas-components/core';
import shell, { StyleProps } from '../../../theme';

const styles = (theme: Theme) => {
    return createStyles({
        searchField: {
            backgroundColor: (props: StyleProps) => shell[props.mode].header.searchField.background,
            borderRadius: 12,
            [theme.breakpoints.down('sm')]: {
                width: '90%',
            },
            '& legend > span': {
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
        searchFieldInput: {
            '& [class*="MuiInputBase-inputHiddenLabel"]': {
                paddingTop: 12.5,
                paddingBottom: 12.5,
                [theme.breakpoints.down('sm')]: {
                    paddingTop: 6.5,
                    paddingBottom: 6.5,
                },
            },
        },
        adornment: {
            color: theme.palette.grey[500],
        },
        notchedOutline: {
            borderRadius: 12,
        },
        searchContainer: {
            maxWidth: 600,
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
        },
        searchContainerIcon: {
            color: (props: StyleProps) => shell[props.mode].header.icon,
        },
        searchItem: {
            textAlign: 'center',
            textDecoration: 'none',
            color: theme.palette.text.primary,
            padding: '20px 0',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                display: 'flex',
                '& svg': {
                    marginRight: 8,
                },
            },
        },
        searchContainerTitle: {
            fontSize: 18,
        },
        searchItemContainer: {
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            borderRadius: theme.spacing(1),
            '&:hover': {
                backgroundColor: alpha(theme.palette.primary.light, 0.2),
            },
            [theme.breakpoints.down('sm')]: {
                alignItems: 'flex-start',
                height: 'auto',
                padding: theme.spacing(2),
            },
        },
        newChip: {
            backgroundColor: theme.palette.primary.main,
            borderRadius: 3,
            color: '#fff',
        },
        paper: {
            [theme.breakpoints.down('sm')]: { paddingTop: 0, position: 'absolute', top: 68, width: '100%' },
            [theme.breakpoints.down('xs')]: { paddingTop: 0, position: 'absolute', top: 60, width: '100%' },
        },
    });
};

export default makeStyles(styles, { name: 'MuiShellSearchField' });
